import React from 'react';
import styles from './ManagerInsuranceCompaniesCaseTypesInsuranceRow.module.scss';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';
import ManagerInsuranceCompaniesEditModal from '../ManagerInsuranceCompaniesEditModal/ManagerInsuranceCompaniesEditModal';
import { WorkplaceMedicalProcedure } from '../../../../Consts/CaseTypesDefaultColumns.const';
import ManagerInsuranceCompaniesCaseTypesInsuranceSettingsIcon from './ManagerInsuranceCompaniesCaseTypesInsuranceSettingsIcon';
import { joinClasses } from '../../../../../../Utils/className.util';

interface Props {
	item: WorkplaceMedicalProcedure;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesCaseTypesInsuranceRow = ({
	item,
	reloadData,
}: Props) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	return (
		<div className={styles.wrapper}>
			{item.insuranceCompanyCodes?.map(code => (
				<span className={styles.item} key={code}>
					{code}
				</span>
			))}
			<span
				className={joinClasses([
					styles.item,
					styles.itemClickable,
					styles.itemWithIcon,
				])}
				onClick={onOpen}>
				<ManagerInsuranceCompaniesCaseTypesInsuranceSettingsIcon />
			</span>
			{isOpen && (
				<ManagerInsuranceCompaniesEditModal
					isOpen
					onClose={onClose}
					item={item}
					reloadData={reloadData}
				/>
			)}
		</div>
	);
};

export default ManagerInsuranceCompaniesCaseTypesInsuranceRow;
